import React from "react";
import ReactDOM from "react-dom";
import { Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import Routes from "./routes";
import store from "./store";
import * as action from "./store/actions";
import { createBrowserHistory } from "history";

// import "./assets/scss/black-dashboard-react.scss";
import "./assets/demo/demo.css";
import "./assets/css/nucleo-icons.css";

const hist = createBrowserHistory();

store.dispatch(action.authCheck());

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        <Routes />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("app")
);
